import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"


const DefaultFamilyResourceSlide1 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Holding a Family Meeting from the Family Caregiving Alliance"
      url="https://www.caregiver.org/resource/holding-family-meeting/"
      descriptionText=""
      taskHeaderText={textTitle}
      />
    <ResourceRow urlText="How to Share Caregiving Responsibilities with Family Members"
      url="https://www.nia.nih.gov/health/how-share-caregiving-responsibilities-family-members"
      descriptionText=""
      />    
    <ResourceRow urlText="Caregiving with your siblings from the Family Caregiver Alliance"
      url="https://www.caregiver.org/resource/caregiving-with-your-siblings/?via=caregiver-resources,all-resources"
      descriptionText=""
      />
    <ResourceRow urlText="Long-Distance Caregiving"
      url="https://www.nia.nih.gov/health/getting-started-long-distance-caregiving"
      descriptionText=""
      />    
    <ResourceRow urlText="Leading Difficult Family Meetings"
      url="https://www.geriatricfastfacts.com/fast-facts/tips-leading-difficult-family-meetings"
      descriptionText=""
      /> 
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide2 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Pets for the Elderly "
      url="https://www.petsfortheelderly.org/our-work/research.php"
      descriptionText="Discusses pets and older adults"
      taskHeaderText={textTitle}
      />
    <ResourceRow urlText="Health Benefits of Companion Animals"
      url="https://cvm.msu.edu/news/perspectives-magazine/perspectives-fall-2018/the-health-benefits-of-owning-a-companion-animal"
      descriptionText=""
      />    
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide3 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Emergency Tips"
        url="https://www.ready.gov/sites/default/files/2020-03/ready_prepare-now-seniors.pdf"
        descriptionText="Tip sheet for emergencies, including how to build a emergency kit."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="In Case of Emergency Form"
        url="https://acl.gov/sites/default/files/programs/2018-10/EmergencyInformation.pdf"
        descriptionText="A form to display on refrigerator that gives EMS workers info about you in case of emergency."
        />
      <ResourceRow urlText="Preparing with Older Adults"
        url="https://www.redcross.org/get-help/how-to-prepare-for-emergencies/older-adults.html"
        descriptionText=""
        groupedHeaderText="Preparing for Emergencies"
        />
      <ResourceRow urlText="Creating Plans"
        url="https://www.ready.gov/plan"
        descriptionText=""
        />    
      <ResourceRow urlText="Red Cross Preparedness Checklist"
        url="https://www.redcross.org/content/dam/redcross/get-help/how-to-prepare/Older_Adults_Disaster_Prep_1Pager_11012022.pdf"
        descriptionText=""
        />
      <ResourceRow urlText="Hurricane Evacuation Planning with Pets"
        url="http://www.coastalpetrescue.org/hurricane.html"
        descriptionText=""
        />
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide4 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="CDC - A Home Fall Prevention Checklist for Older Adults"
        url="https://uvahealth.com/sites/default/files/2018-08/Fall-Prevention-Checklist.pdf"
        descriptionText="The Center for Disease Control's fall prevention checklist"
        taskHeaderText={textTitle}
        />
      <ResourceRow urlText="Safe At Home Checklist"
        url="https://www.aota.org/~/media/Corporate/Files/Practice/Aging/rebuilding-together/RT-Aging-in-Place-Safe-at-Home-Checklist.pdf"
        descriptionText="Administration on Aging checklist for home safety"
        />    
      <ResourceRow urlText="Home Modifications"
        url="https://acl.gov/sites/default/files/news%202017-03/Home_Modification.pdf"
        descriptionText="Home Modification Guidelines from the Administration on Aging"
        />
      <ResourceRow urlText="Home Safety Evaluation Checklist"
        url="https://www.geriatricfastfacts.com/fast-facts/home-safety-evaluation-can-i-send-patient-home"
        descriptionText=""
        />    
      <ResourceRow urlText="NIH Home Safety Techniques"
        url="https://www.ncbi.nlm.nih.gov/books/NBK560539/"
        descriptionText=""
        /> 
      <ResourceRow urlText="Health in Aging Tip Sheet"
        url="https://www.healthinaging.org/tools-and-tips/tip-sheet-home-safety-tips-older-adults"
        descriptionText=""
        />    
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide5 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Older Adults and Technology Use"
        url="https://www.pewresearch.org/internet/2014/04/03/older-adults-and-technology-use/"
        descriptionText=""
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="How Technology Can Help Seniors"
        url="https://www.seniorliving.org/tech/"
        descriptionText=""
        /> 
      <ResourceRow urlText="Tips to Avoid Internet Scams"
        url="https://aginginplace.org/internet-scams-affecting-elderly/"
        descriptionText=""
        />   
      <ResourceRow urlText="Calming Computer Jitters: Help for Seniors Who Aren't Tech-Savvy"
        url="https://khn.org/news/article/calming-computer-jitters-help-for-seniors-who-arent-tech-savvy/"
        descriptionText="Discussing tech training for seniors and different avenues to do so."
        groupedHeaderText="Tech Tips for Seniors"
        />
      <ResourceRow urlText="Tips on Helping Seniors Learn Technology"
        url="https://www.saberhealth.com/news/blog/help-seniors-learn-technology"
        descriptionText=""
        />    
      <ResourceRow urlText="Technology for Seniors Made Easy"
        url="https://www.rightathome.net/blog/technology-for-seniors"
        descriptionText="Technology Helps Seniors Remain at Home"
        /> 
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide6 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Tips for Hiring In-Home Help Through an Agency"
        url="https://www.caregiver.org/resource/10-tips-for-hiring-in-home-help-through-an-agency/"
        descriptionText="Article by Family Caregiver Alliance."
        taskHeaderText={textTitle}
        groupedHeaderText="Tips for Finding a Caregiver"
        />
      <ResourceRow urlText="Hiring In-Home Help"
        url="https://www.caregiver.org/resource/hiring-home-help/"
        descriptionText="By Family Caregiver Alliance "
        />    
      <ResourceRow urlText="Hiring an In-Home Caregiver: A Step-by-Step Guide"
        url="https://www.aplaceformom.com/caregiver-resources/articles/hiring-an-in-home-caregiver"
        descriptionText="An article by 'A Place for Mom' "
        />
      <ResourceRow urlText="How to Hire In-Home Help"
        url="https://www.consumerreports.org/elder-care/how-to-hire-in-home-help/"
        descriptionText="By Consumer Reports. Take these steps to find someone you can trust."
        />    
      <ResourceRow urlText="Choosing an In-Home Care Provider"
        url="https://udservices.org/in-home-care-provider-questions/"
        descriptionText="A pdf guide by the Alzheimer's Association."
        groupedHeaderText="Tips for Finding a Caregiver for Hospice and/or Alzheimer's Patients"
        /> 
      <ResourceRow urlText="How Do I Select the Right Home Care Provider?"
        url="https://www.nahc.org/consumers-information/home-care-hospice-basics/right-home-care-provider/"
        descriptionText="By the National Association for Home Care & Hospice."
        />    
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide7 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="The Art of Grandparenting Publication"
        url="https://www.ag.ndsu.edu/publications/kids-family/the-art-of-grandparenting-no-1-in-the-series#section-9"
        descriptionText=""
        taskHeaderText={textTitle}
        />
      <ResourceRow urlText="Long Distance Grandparenting"
        url="https://lastingthedistance.com/long-distance-grandparents/"
        descriptionText=""
        />    
      <ResourceRow urlText="Online Grandparenting Classes"
        url="https://www.scripps.org/news_items/3385-grandparenting-classes-preparing-for-a-role-of-a-lifetime"
        descriptionText=""
        />
      <ResourceRow urlText="Joys & Challenges of Grandparenting"
        url="https://greatergood.berkeley.edu/article/item/how_to_navigate_the_joys_and_challenges_of_grandparenting"
        descriptionText=""
        groupedHeaderText="Grandparenting Tips"
        />    
      <ResourceRow urlText="Grandkids Matter"
        url="https://grandkidsmatter.org/"
        descriptionText=""
        /> 
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide8 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Reading the Family Narrative Backwards"
        url="http://newoldage.blogs.nytimes.com/2008/10/09/reading-the-family-narrativebackwards/?pagemode=print"
        descriptionText="“Reading the Family Narrative Backwards” - an opinion piece on caregivers"
        taskHeaderText={textTitle}
        />
      <ResourceRow urlText="Techniques to Relieve Caregiver Stress"
        url="https://www.caringbridge.org/resources/techniques-to-relieve-caregiver-stress"
        descriptionText=""
        />    
      <ResourceRow urlText="Caring for Yourself"
        url="https://www.caregiver.org/caregiver-resources/caring-for-yourself/"
        descriptionText=""
        groupedHeaderText="Tips on Preventing Caregiver Burnout"
        />
      <ResourceRow urlText="Resources for Taking Care of Yourself"
        url="https://www.caregiver.org/resource/taking-care-you-self-care-family-caregivers/"
        descriptionText=""
        />    
      <ResourceRow urlText="What is Respite Care?"
        url="https://www.nia.nih.gov/health/what-respite-care"
        descriptionText=""
        groupedHeaderText="Information on Respite Care for Caregivers"
        /> 
      <ResourceRow urlText="Help & Support with Respite Care"
        url="https://www.alz.org/help-support/caregiving/care-options/respite-care"
        descriptionText=""
        />    
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide9 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Aging in Place with Habitat for Humanity "
        url="https://www.habitat.org/our-work/aging-in-place?gclid=CjwKCAiAmJGgBhAZEiwA1JZolisCDYmRYx_1iBXP3fJolaQzuiKMQQmQhEQe28k9OA5VWT3-pPbjAhoC7lgQAvD_BwE"
        descriptionText=""
        taskHeaderText={textTitle}
        />
      <ResourceRow urlText="AARP HomeFit Guide (download page)"
        url="https://www.aarp.org/livable-communities/housing/info-2020/homefit-guide-download.html"
        descriptionText="Smart ways to make a home comfortable, safe and a great fit for older adults — and people of all ages."
        groupedHeaderText="Checklists for Home Maintenance"
        />    
      <ResourceRow urlText="The Annual Home Maintenance Checklist"
        url="https://www.nytimes.com/guides/realestate/home-maintenance-checklist"
        descriptionText="By the New York Times."
        />
      <ResourceRow urlText="The Home Maintenance Checklist For Retirees"
        url="https://www.forbes.com/sites/northwesternmutual/2015/11/02/the-home-maintenance-checklist-for-retirees/?sh=cef59e74fb37"
        descriptionText="By Forbes."
        />    
      <ResourceRow urlText="Home Maintenance Tips and Resources for Seniors"
        url="https://www.senioradvisor.com/blog/2016/12/home-maintenance-tips-and-resources-for-seniors/"
        descriptionText="By 'OurParents'."
        groupedHeaderText="Home Maintenance Tips"
        /> 
      <ResourceRow urlText="41 Home Maintenance Tips: Save Your House"
        url="https://lula.life/home-maintenance-tips"
        descriptionText="By 'Lula Life'."
        />    
    </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide10 = (textTitle: string) => {
  return (
    
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Widow's Connection"
        url="https://widowsconnection.org/"
        descriptionText="The W Connection is a national non-profit of widows helping widows rebuild their lives after the life-changing 
        event of losing a spouse."
        groupedHeaderText="Support for Widows"
        taskHeaderText={textTitle}
        />
      <ResourceRow urlText="National Widowers"
        url="https://nationalwidowers.org/"
        descriptionText="The National Widowers' Organization is a virtual toolkit for men coping with the loss of a loved one, a place 
        where men can meet others going through the same transition."
        />    
      <ResourceRow urlText="Wings for Widows"
        url="https://wingsforwidows.org/"
        descriptionText="Wings for Widows provides free, professional coaching and education to help widowed men and women navigate the 
        financial trauma experienced in widowhood. They provide comprehensive advice, guidance, and encouragement when it's most needed."
        />
      <ResourceRow urlText="The Widowhood Effect: How to Survive the Loss of a Spouse"
        url="https://www.ncoa.org/article/the-widowhood-effect-how-to-survive-the-loss-of-a-spouse"
        descriptionText="By the National Council on Aging."
        />    
    </Segment.Group>
    </>
  );
};

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    { key: 'keyVal',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />, 
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label> },
      content: { 
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()}/>)
      }
    }
  ];

  return (
    <>
    <div className={styles.resourceAccordionWrapper}>
      <Accordion panels={accordions} defaultActiveIndex={0} />
    </div>
    </>
  );

}

const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('FamilyDomainTask1', 'Family Meeting Resources', () => DefaultFamilyResourceSlide1(""))}
      {accordionResourceDisplay('FamilyDomainTask2', 'Companion Animals Resources', () => DefaultFamilyResourceSlide2(""))}
      {accordionResourceDisplay('FamilyDomainTask3', 'Crisis Planning Resources', () => DefaultFamilyResourceSlide3(""))}
      {accordionResourceDisplay('FamilyDomainTask4', 'Home Safety Resources', () => DefaultFamilyResourceSlide4(""))}
      {accordionResourceDisplay('FamilyDomainTask5', 'Using Technology Resources', () => DefaultFamilyResourceSlide5(""))}
      {accordionResourceDisplay('FamilyDomainTask6', 'Choosing Paid Caregivers Resources', () => DefaultFamilyResourceSlide6(""))}
      {accordionResourceDisplay('FamilyDomainTask7', 'Grandparent Relationships Resources', () => DefaultFamilyResourceSlide7(""))}
      {accordionResourceDisplay('FamilyDomainTask8', 'Caring For Yourself Resources', () => DefaultFamilyResourceSlide8(""))}
      {accordionResourceDisplay('FamilyDomainTask9', 'Home Maintenance Resources', () => DefaultFamilyResourceSlide9(""))}
      {accordionResourceDisplay('FamilyDomainTask10', 'Widowhood Support Resources', () => DefaultFamilyResourceSlide10(""))}
    </>
  );
};

const FamilyResourcesFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;

  switch( questionKey ) {
    case "FamilyDomainTask1":
      return DefaultFamilyResourceSlide1('Family Meeting');
    case "FamilyDomainTask2":
      return DefaultFamilyResourceSlide2('Companion Animals');
    case "FamilyDomainTask3":
      return DefaultFamilyResourceSlide3('Crisis Planning');
    case "FamilyDomainTask4":
      return DefaultFamilyResourceSlide4('Home Safety');
    case "FamilyDomainTask5": 
      return DefaultFamilyResourceSlide5('Using Technology');
    case "FamilyDomainTask6":
      return DefaultFamilyResourceSlide6('Choosing Paid Caregivers');
    case "FamilyDomainTask7":
      return DefaultFamilyResourceSlide7('Grandparent Relationships');
    case "FamilyDomainTask8":
      return DefaultFamilyResourceSlide8('Caring For Yourself');    
    case "FamilyDomainTask9":
      return DefaultFamilyResourceSlide9('Home Maintenance');  
    case "FamilyDomainTask10":
      return DefaultFamilyResourceSlide10('Widowhood Support');
    case "":
      return AllResources();
    default:
      return null;
  };
};

export default FamilyResourcesFactory;
